import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './cartSlice';
import { TENANT_SLUG } from '../lib/tenant';

// Scope the cart's localStorage key by tenant so opening test.lvh.me
// and acme.lvh.me doesn't share a cart.
const CART_KEY = `cart::${TENANT_SLUG || 'root'}`;

const loadCart = () => {
  try {
    const raw = localStorage.getItem(CART_KEY);
    return raw ? { cart: JSON.parse(raw) } : undefined;
  } catch {
    return undefined;
  }
};

export const store = configureStore({
  reducer: { cart: cartReducer },
  preloadedState: loadCart(),
});

let timer: ReturnType<typeof setTimeout> | null = null;
store.subscribe(() => {
  // Debounce so rapid dispatches (e.g. adding a bundle of 5 items) only
  // result in one localStorage write.
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => {
    try {
      localStorage.setItem(CART_KEY, JSON.stringify(store.getState().cart));
    } catch {
      // Quota / private mode — ignore.
    }
  }, 200);
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
